import { useEffect, useRef, useState } from 'react';
import { nanoid } from 'nanoid';
import { SharedUtils, ValidationUtils } from '../utils';
// @ts-ignore
import kountSDK from '@kount/kount-web-client-sdk';
import ddLogger from '../logging/ddLogger';
import { StorageKeys } from '../types/keys.type';

export function useKountLoader() {
    const kountClientId = ValidationUtils.validateAndGetEnvVar('REACT_APP_KOUNT_CLIENT_ID');
    const isProduction = ValidationUtils.validateAndGetEnvVar('REACT_APP_CUSTOM_NODE_ENV') === 'production';

    const [sessionID, setSessionID] = useState(() => {
        let existingSessionID = SharedUtils.getSessionStorageItem(StorageKeys.KOUNT_SESSION_ID);
        if (!existingSessionID) {
            existingSessionID = nanoid(32);
            SharedUtils.setSessionStorageItem(StorageKeys.KOUNT_SESSION_ID, existingSessionID);
        }
        return existingSessionID;
    });

    const hasLoadedKount = useRef(false);

    useEffect(() => {
        if (!hasLoadedKount.current) {
            try {
                const kountConfig = {
                    clientID: kountClientId,
                    environment: isProduction ? 'PROD' : 'TEST',
                    isSinglePageApp: true,
                };
                kountSDK(kountConfig, sessionID);
                hasLoadedKount.current = true;
            } catch (e) {
                ddLogger.error(`Error trying to execute kount | ${e}`, { error: e });
            }
        }
    }, [sessionID]);
}
